import { render, staticRenderFns } from "./NwFormBo.vue?vue&type=template&id=2b1be2ab&scoped=true&"
import script from "./NwFormBo.vue?vue&type=script&lang=js&"
export * from "./NwFormBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1be2ab",
  null
  
)

export default component.exports